import templateUrl from "./user-profile-onboarding-details.component.html";
export const UserProfileOnboardingDetailsComponent = {
    templateUrl,
    bindings: {
        userProfile: "<"
    }
};
